import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CoreProvider } from '../core.provider';
import { LoginRequestDto, SessionDto, UserModelDto, UserRegisterDto } from '../api/models';
import { SessionDtoExtended } from './session-dto-extended';
import { HttpContext } from '@angular/common/http';
import { CUSTOM_REQUEST_AUTHORIZATION } from './auth.interceptor';

@Injectable({
  providedIn: "root",
})
export class AuthService {

  public get liveTokens(): SessionDto | undefined {
    const tokensData = localStorage.getItem('live-tokens');
    if (!tokensData) return undefined;
    return JSON.parse(tokensData);
  }

  private userData?: UserModelDto | null = null;
  public get user(): UserModelDto | undefined {
    return this.userData || undefined;
  }
  public get isAuthenticated(): boolean | null {
    if (this.userData === null) return null;
    return !!this.userData;
  }

  private core!: CoreProvider;
  initCore(core: CoreProvider) {
    this.core = core;
    this.initialiseAuth();
  }

  async initialiseAuth() {
    const tokens = this.liveTokens;
    if (!tokens) {
      this.userData = undefined;
      return;
    }

    // console.log(await firstValueFrom(this.core.api.auth.authControllerMe({}))) // Strange workaround for circular dependency

    // TODO: Implement a refresh token mechanism

    // NOTE: It is strongly important to all init api calls be done after auth initialization or at least prevent loops when injecting core provider at auth interceptor
    try {
      const reqCtx = new HttpContext().set(CUSTOM_REQUEST_AUTHORIZATION, `Bearer ${tokens.accessToken}`);
      const user = await firstValueFrom(this.core.api.auth.authControllerMe({}, reqCtx))
      this.userData = {...user}; // , lastname: ''
      console.log('User data', user);
    } catch (err: any) {
      this.userData = undefined;
      console.error('Error fetching user data', err);
      if (err.status === 401) { // usually HttpErrorResponse, if not, status is undefined and if not true
        this.logout(); // Maybe move to interceptor
      }
    }
  }

  async login(login: LoginRequestDto): Promise<SessionDtoExtended> {
    const sess = await firstValueFrom(this.core.api.auth.authControllerLogin({body: login})); // Can throw an error to caller
    const session = new SessionDtoExtended(sess);
    localStorage.setItem('live-tokens', JSON.stringify(session));
    await this.initialiseAuth();
    return session;
  }

  async register(login: UserRegisterDto): Promise<SessionDtoExtended> {
    const sess = await firstValueFrom(this.core.api.auth.authControllerRegister({body: login})); // Can throw an error to caller
    const session = new SessionDtoExtended(sess);
    localStorage.setItem('live-tokens', JSON.stringify(session));
    await this.initialiseAuth();
    return session;
  }

  logout() {
    localStorage.removeItem('live-tokens');
    this.userData = undefined;
    this.core.router.navigate(['/auth/login']);
  }

}